module.exports = __webpack_public_path__ + "img/1539365064.cff54077.jpg";